import { useEffect, useState } from "react";

export function usePageTransition() {
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Trigger enter animation after mount using rAF to defer to next frame
    const frameId = requestAnimationFrame(() => {
      setIsVisible(true);
      setIsExiting(false);
    });

    return () => {
      cancelAnimationFrame(frameId);
    };
  }, []);

  return { isVisible, isExiting };
}
